module.exports = __webpack_public_path__ + "static/media/computer-landing-briiing-mobile.07ff27d4.webp";